const Options = [
  "Default",
  "ExHedges",
  "ExOffsets",
  "ExDerivatives",
  "ExDerivativeOffsets",
  "DerivativeExOffsets",
  "ExCurrencyForwards",
  "ExCurrencyForwardOffsets",
  "NonZeroWeighted",
];

export default Options;
